import { render } from "./GruposPrecioView.vue?vue&type=template&id=2c2b060b&scoped=true"
import script from "./GruposPrecioView.vue?vue&type=script&lang=js"
export * from "./GruposPrecioView.vue?vue&type=script&lang=js"

import "./GruposPrecioView.vue?vue&type=style&index=0&id=2c2b060b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2b060b"]])

export default __exports__